<template>
    <v-expansion-panels inset>
        <v-expansion-panel>
            <v-expansion-panel-header>
                <strong>{{ $t('calendar_appointment')}} </strong>   
                <v-divider vertical style="margin-right:5px;margin-left:5px;"></v-divider> 
                <b class="blue--text">
                    {{ $t('display_date') }} : {{ select_date == null ? $t('all_day') : select_date }}
                    <v-btn tile icon @click="onClearDate" v-if="select_date != null">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </b>
                <v-spacer></v-spacer> <v-spacer></v-spacer> <v-spacer></v-spacer> 
                </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-container>
                    <v-sheet align="center">
                        <Calendar
                            :columns="$screens({ default: 1, lg: 4 })"
                            @dayclick="onDate"
                            :attributes='calendar_attrs'
                            :locale="{id:$i18n.locale }"
                            :available-dates="available_dates"
                        >
                        </Calendar>
                    </v-sheet>
                </v-container>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
import Calendar from 'v-calendar/lib/components/calendar.umd'
import axios from 'axios';
import config from '@/../config.js'
import Staff from '@/model/instance/Staff.js'

export default {
    props: ['station_code'],
    components: {
        Calendar
    },
    data: () => ({
        select_date: null,
        available_dates : [],
        calendar_attrs : [{
            bar: 'purple',
            dates: new Date(),
        }],
    }),
    methods: {
        onDate(date){
            this.select_date = date.id
            this.$emit('oncalendar', this.select_date)

            this.calendar_attrs.forEach((v,i,arr)=>{
                arr[i].highlight = false
            })
            this.calendar_attrs.push({highlight: true,dates: this.select_date})

            var today = new Date()
            today.setHours(today.getHours()+7)
            this.calendar_attrs.push({highlight: {color:'orange',fillMode: 'light'},dates: today.toISOString().substring(0,10)})
        },
        onClearDate(){
            this.select_date = null
            this.$emit('oncalendar', this.select_date)

            this.calendar_attrs.forEach((v,i,arr)=>{
                arr[i].highlight = false
            })
            var today = new Date()
            today.setHours(today.getHours()+7)
            this.calendar_attrs.push({highlight: {color:'orange',fillMode: 'light'},dates: today.toISOString().substring(0,10)})
            
        },
        reload(){

            this.calendar_attrs.forEach((v,i,arr)=>{
                arr[i].highlight = false
                arr[i].bar = false
                arr[i].popover = {}
            })

            var que = this.$store.commit('addLoading')
            axios.post(config.api.url.manage.appointment.manage.search_calendar,{
                station_code : this.station_code
                ,query : { station_code_list:[this.station_code] }
            },{ headers: Staff.getTokenHeader()})
            .then(response => {
                this.$store.commit('finishLoading',que)
                response.data.calendar.forEach(c=>{
                    this.calendar_attrs.push({
                        bar: 'purple'
                        ,dates: c.datee
                        ,popover: {
                            label: Object.keys(c.status).reduce((v,k)=> v+c.status[k],0),
                        }
                    })
                })
                if(this.select_date!=null){
                    this.calendar_attrs.push({highlight: true,dates: this.select_date})
                }
                var today = new Date()
                today.setHours(today.getHours()+7)
                this.calendar_attrs.push({highlight: {color:'orange',fillMode: 'light'},dates: today.toISOString().substring(0,10)})
            }).catch(error => {
                this.$router.push({name:'Error',params:error})             })
        }
    },
    mounted : function () {
        var que = this.$store.commit('addLoading')
        axios
        .post(config.api.url.manage.appointment.manage.get_calendar,{station_code:this.station_code},{ headers: Staff.getTokenHeader()})
        .then(response => {
            this.available_dates = []
            response.data.calendars.forEach(car=>{
                car.calendar.forEach(c=>{
                    if(!c.is_close){
                        var datee = new Date(c.datee);
                        datee.setHours(datee.getHours() + 7);
                        this.available_dates.push(datee.toISOString().substring(0,10));
                    }
                })
            })
            //res.json({calendars:Array.from(new Set(result))})
            this.$store.commit('finishLoading',que)
        })
        this.reload()
    } 
}
</script>